module.exports = __webpack_public_path__ + "static/media/wurlitzerCd01.a33e816c.jpg";